import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { vendorOfferingsRoute } from 'features/vendor-offerings/VendorOfferingsView';
import { menuLayoutRoute } from 'root/MenuLayout';

import { vendorCommunicationRouteTree } from './VendorCommunicationView';
import { vendorDetailsRoute } from './VendorDetailsView';
import { vendorContractsRoute, vendorDocumentsRoute } from './VendorDocumentsView';
import { fundingsRoute, singleCampaignRoute } from './VendorFundingsView';
import {
  fundingTermsLegacyPathRedirectRoute,
  vendorFundingsRoute,
  vendorLayoutRoute,
} from './VendorLayout';
import { vendorSettingsRoute } from './VendorSettingsView';
import { VendorsLayout } from './VendorsLayout';
import { vendorsListRoute } from './VendorsView';

export const vendorsMainRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  path: 'vendors',
});

export const vendorsLayoutRoute = createRoute({
  id: 'vendorsLayout',
  getParentRoute: () => vendorsMainRoute,
  validateSearch: z.object({
    from: z.string().optional(),
    search: z.coerce.string().optional(),
    createModalOpen: z.boolean().optional(),
    page: z.coerce.number().optional(),
    uploadDeliveryScheduleModalOpen: z.boolean().optional(),
    uploadOrderingConditionsModalOpen: z.boolean().optional(),
    venueCodes: z.array(z.string()).optional(),
  }),
  component: VendorsLayout,
});

export const vendorsRouteTree = vendorsMainRoute.addChildren({
  vendorsLayoutRoute: vendorsLayoutRoute.addChildren({
    vendorsListRoute,
    fundingsRoute,
  }),
  vendorCommunicationRouteTree,
  singleCampaignRoute,
  vendorLayoutRoute: vendorLayoutRoute.addChildren({
    vendorDetailsRoute,
    vendorOfferingsRoute,
    vendorContractsRoute,
    vendorDocumentsRoute,
    vendorSettingsRoute,
    vendorFundingsRoute,
    fundingTermsLegacyPathRedirectRoute,
  }),
});
